export const providerTypes = {
  DOCTOR_CONSULTAION: 1,
  PHARMACIES: 2,
  LABS: 3,
  SCANS: 4,
  INCLINIC_SERVICES: 5,
  SURGICAL: 5,
};
